// Copyright (c) StrangeBee 2024

import React, { ReactElement, useCallback, useContext, useEffect, useState } from 'react';
import { BrandingParams, AuditOutput } from 'thehive-sdk';
import { getAvatarUrl } from '@Helpers/images';
import { useLocalMessage } from '@Helpers/locale';
import { deduplicateAudit, LiveStreamData } from '@Organisms/LiveStreamData/LiveStreamData';
import { DisplayEmptyData } from '@Atoms/Display/DisplayEmptyData/DisplayEmptyData';
import { useStreamObserver } from '@Hooks/useStream';
import { STREAM_EVENTS } from '@Services/StreamSrv';
import client from '@Client';

import './LiveListPage.scss';
import { StreamContext } from '@Context/StreamProvider';

interface LiveFeedPageProps {
    brandingData?: BrandingParams;
}

const LiveFeedPage = ({ brandingData }: LiveFeedPageProps): ReactElement | null => {
    const local = useLocalMessage();
    const [liveFeed, setLiveFeed] = useState<AuditOutput[]>([]);
    const [status, setStatus] = useState('loading');
    const { streamReady } = useContext(StreamContext);

    const refreshFeed = useCallback(() => {
        client.StreamController.getInitialFeed()
            .then((data: AuditOutput[]) => {
                if (data) {
                    setLiveFeed(deduplicateAudit(data));
                }
            })
            .finally(() => {
                setStatus('done');
            });
    }, []); //eslint-disable-line

    useStreamObserver(
        { objectType: STREAM_EVENTS.ANY },
        (data) => {
            setLiveFeed(deduplicateAudit([...data, ...liveFeed]));
        },
        [liveFeed, setLiveFeed],
    );

    useEffect((): void => {
        refreshFeed();
    }, [refreshFeed, streamReady]);

    return (
        <div className="window-list">
            <div className="window-list_header">
                <img
                    className="window-list_header-logo"
                    src={brandingData?.menuLogo ? getAvatarUrl(brandingData.menuLogo) : `static/images/logo.bee.svg`}
                    alt="logo"
                />
                <span className="header-title__text">{local('mainLayout.liveFeed.title')}</span>
            </div>
            {liveFeed.length && status === 'done' ? (
                <LiveStreamData liveFeed={liveFeed} />
            ) : (
                <DisplayEmptyData spin={status === 'loading'} label={local('stream.none')} />
            )}
        </div>
    );
};
export default LiveFeedPage;
